import { backdrop } from "../../lib/a11y";
import { CATEGORIES } from "./cookieStore";

/** Modale de gestion fine des catégories de cookies. */
export const CookiePreferencesModal = ({ granular, setGranular, onClose, onRefuseAll, onSave }) => (
  <div
    data-testid="cookie-modal"
    className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4"
    {...backdrop(onClose, { selfOnly: true })}
  >
    <div className="bg-neutral-950 border border-neutral-900 max-w-lg w-full max-h-[92vh] overflow-y-auto">
      <div className="p-5 border-b border-neutral-900">
        <p className="text-[10px] tracking-[0.25em] uppercase text-[#c9a962] mb-1">Cookies · gestion fine</p>
        <h3 className="font-serif text-xl text-neutral-100">Vos préférences</h3>
      </div>
      <div className="p-5 space-y-4">
        {CATEGORIES.map((cat) => (
          <label key={cat.key} aria-label={cat.label} className="flex items-start gap-3 cursor-pointer">
            <input
              data-testid={`cookie-cat-${cat.key}`}
              type="checkbox"
              disabled={cat.req}
              checked={cat.req ? true : Boolean(granular[cat.key])}
              onChange={(e) => setGranular((g) => ({ ...g, [cat.key]: e.target.checked }))}
              className="mt-1 accent-[#c9a962] w-4 h-4 disabled:opacity-50"
            />
            <div className="flex-1">
              <p className="text-sm text-neutral-100">{cat.label}
                {cat.req && <span className="text-[10px] tracking-widest uppercase text-neutral-500 ml-2">obligatoire</span>}
              </p>
              <p className="text-[11px] text-neutral-500 leading-relaxed mt-0.5">{cat.desc}</p>
            </div>
          </label>
        ))}
      </div>
      <div className="p-5 border-t border-neutral-900 flex flex-wrap gap-2 justify-end">
        <button
          data-testid="cookie-modal-cancel"
          onClick={onClose}
          className="px-3 py-2 text-[10px] tracking-widest uppercase border border-neutral-700 text-neutral-400"
        >
          Annuler
        </button>
        <button
          data-testid="cookie-modal-refuse-all"
          onClick={onRefuseAll}
          className="px-3 py-2 text-[10px] tracking-widest uppercase border border-neutral-700 text-neutral-300"
        >
          Refuser tout
        </button>
        <button
          data-testid="cookie-modal-save"
          onClick={onSave}
          className="px-3 py-2 text-[10px] tracking-widest uppercase bg-[#c9a962] text-neutral-950 font-semibold"
        >
          Enregistrer mes choix
        </button>
      </div>
    </div>
  </div>
);

export default CookiePreferencesModal;
